import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"search\"><path d=\"M9 3a6 6 0 1 1 0 12A6 6 0 0 1 9 3Zm0 1a5 5 0 1 0 0 10A5 5 0 0 0 9 4Z\" /><path d=\"M12.646 12.646a.5.5 0 0 1 .638-.057l.07.057 3.5 3.5a.5.5 0 0 1-.638.765l-.07-.057-3.5-3.5a.5.5 0 0 1 0-.708Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol